import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cycle-connect-presentation',
  templateUrl: './cycle-connect-presentation.component.html',
  styleUrls: ['./cycle-connect-presentation.component.scss']
})
export class CycleConnectPresentationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
